import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { init } from '@sentry/angular-ivy';
import { AppModule } from './app/common';
import { environment } from "./environments/";
import { register } from 'swiper/element/bundle';

register()

// Error tracking only (no tracing, no session replay) to stay within the
// Sentry Developer plan quota. Production only, so local/dev noise never
// counts against it.
if (environment.production && environment.sentryDsn) {
  init({
    dsn: environment.sentryDsn,
    environment: environment.environmentName,
    release: `${environment.environmentName}-${environment.version}`,
    tracesSampleRate: 0,
    beforeSend(event) {
      const message = event.exception?.values?.[0]?.value ?? '';
      if (/ResizeObserver loop|Non-Error promise rejection captured/.test(message)) {
        return null;
      }
      return event;
    },
  });
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
